<!-- Start of PROFILE container -->

<div class="">


    <div class="col card mr-3  shade" *ngIf="organisation !== 'null'">

        <div class="h-100  dash-message " *ngFor="let profile of role_based_profiles[role]">


            <h5 class="alert bg-primary text-white card-title pt-2 header-title heading-color ">
                Patient Profile
            </h5>

            <div class="row text-center ">



                <div class="col">
                    <div class="card shade">

                        <div class="card-body">
                            <div class="row d-flex m-t-20 m-b-20">

                                <div class="btn-mb-5 col-12 col-lg-12 col-sm-12 col-md-12 m-t-20 text-center"
                                    style="margin-top: 30px;">
                                    <a href="" [routerLink]="[profile.create_url]"
                                        class="btn btn-outline-primary radius m-r">Create
                                        Profile</a>
                                    <a href="" [routerLink]="[profile.edit_url]"
                                        class="btn btn-outline-success radius m-r">Edit
                                        Profile</a>
                                    <a href="" [routerLink]="[profile.delete_url]"
                                        class="btn btn-outline-danger radius m-r">Delete
                                        Profile</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <br /><br />


        </div>
    </div>


    <div class="row" *ngIf="!organisation || organisation === 'null'">
        <div class="col-lg-12 col-sm-12">
            <div class="card">
                <div class="card-body">
                    <p class="text-danger font-size-17">
                        Please complete the Registration Process first in order to create profiles for Physicain,
                        Patient and
                        Frontdesk person.
                    </p>
                    <p><a routerLink="/info-basic" class="text-primary">Click Here</a> to create your Organisation
                        Profile.</p>
                </div>
            </div>

        </div>
    </div>



</div>